import type { MultiSelectPassThroughOptions } from 'primevue/multiselect';
export const genericMultiselectPtOptions: MultiSelectPassThroughOptions = {
    root: {
        class: 'p-0',
    },
    closeButton: {
        class: 'bg-transparent hover:bg-transparent focus:bg-transparent hover:shadow-none focus:shadow-none focus:outline-none',
    },
    emptyMessage: {
        class: 'text-center text-ds-primary-500',
    },
    header: {
        class: 'p-0',
    },
    headerCheckbox: {
        class: 'flex mr-4',
    },
    filterContainer: {
        class: 'w-100 flex-grow flex flex-row-reverse',
    },
    token: {
        class: 'rounded-md text-xs my-0',
    },
    item: {
        class: 'flex',
    },
};
